import errorsForField from "./errorsForField";

// takes in parameters to Field render prop and adds field.invalid and fieldErrors
export default function withErrors(component) {
  return (props) => {
    const { form, field } = props;
    const errors = errorsForField(form, field.name);
    const fieldErrors = (errors && !Array.isArray(errors)) ? [errors] : errors;

    const enhancedProps = {
      ...props,
      fieldErrors
    };

    if (fieldErrors) {
      enhancedProps.field.invalid = true;
    }

    return component(enhancedProps);
  };
}
